import React from "react";
import { Form, FloatingLabel, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { HeaderLabel } from "../Labels.tsx";
import { ActionButton } from "../Buttons.tsx";

import { useHomeContext } from "../../views/Home/HomeView.context.tsx";

const SettingsFormUI: React.FC = () => {
  const { t } = useTranslation();
  const { handleSubmitSettings, handleChangeSettings, settingsData, isLoading, loadingComponent } =
    useHomeContext();

  const arePropsEmpty = (obj: Record<string, any>): boolean =>
    Object.values(obj).every((value) => value === "");

  if (isLoading || !settingsData || arePropsEmpty(settingsData)) {
    return loadingComponent;
  }

  return (
    <Col xs={12} sm={12} md={8} lg={6} xl={4} className="p-0">
      <div className="m-4 settings">
        <HeaderLabel textAlign="left">{t("settings.title", { defaultValue: "" })}</HeaderLabel>

        <Form
          noValidate
          onSubmit={handleSubmitSettings}
          className="p-4 rounded-4 d-flex flex-column card"
        >
          {/* Language */}
          <FloatingLabel
            controlId="settingsLanguage"
            label={t("settings.language", { defaultValue: "" })}
            className="mb-3"
          >
            <Form.Select name="locale" value={settingsData?.locale} onChange={handleChangeSettings}>
              <option value="en-US">{t("settings.languages.en")}</option>
              <option value="es-MX">{t("settings.languages.es")}</option>
            </Form.Select>
          </FloatingLabel>

          {/* Units */}
          <FloatingLabel
            controlId="settingsUnits"
            label={t("settings.measurementSystem", { defaultValue: "" })}
            className="mb-3"
          >
            <Form.Select
              name="unit_system"
              value={settingsData?.unit_system}
              onChange={handleChangeSettings}
            >
              <option value="Imperial">{t("settings.units.imperial")}</option>
              <option value="SI">{t("settings.units.si")}</option>
            </Form.Select>
          </FloatingLabel>

          {/* Theme */}
          <FloatingLabel
            controlId="settingsTheme"
            label={t("settings.theme", { defaultValue: "" })}
            className="mb-3"
          >
            <Form.Select name="theme" value={settingsData?.theme} onChange={handleChangeSettings}>
              <option value="dark">{t("settings.themes.dark")}</option>
              <option value="light">{t("settings.themes.light")}</option>
              <option value="system">{t("settings.themes.system")}</option>
            </Form.Select>
          </FloatingLabel>

          <ActionButton type="submit" margin={"0"}>
            {t("settings.save")}
          </ActionButton>
        </Form>
      </div>
    </Col>
  );
};

export default SettingsFormUI;
